import { useAppDispatch } from 'store/hooks';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuthToken } from 'components/auth/getAuthToken';
import { tenantAccessApi } from 'components/merchant/tenantAccessApi';
import { JOIN, SIGN_UP, USER_MERCHANTS } from 'config/routes';
import { httpClient } from 'lib/HttpClient';
import { signOut } from 'store/auth/authSlice';
import { useSnackbar } from 'notistack';
import { Throbber } from 'ui/Throbber';
import logger from 'lib/logger';
import { ELocalStorageKey } from 'config/storageKeys';

function JoinPage() {
    const { enqueueSnackbar } = useSnackbar();
    const [error, setError] = React.useState(null);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(useLocation().search);
    const queryToken =
        queryParams.get(ELocalStorageKey.JoinTokenQueryParameter) ||
        localStorage.getItem(ELocalStorageKey.JoinTokenQueryParameter);
    if (!queryToken) {
        navigate(SIGN_UP);
    }

    function handleError() {
        localStorage.setItem(ELocalStorageKey.JoinTokenQueryParameter, queryToken);
        dispatch(signOut());
        navigate(`${SIGN_UP}?redirectTo=${JOIN}`);
        enqueueSnackbar(error, { variant: 'warning' });
    }

    if (error) {
        handleError();
    }

    async function activateTenant() {
        const authToken = await getAuthToken();
        httpClient.updateToken(authToken);
        if (authToken) {
            try {
                const result = await tenantAccessApi.createNewToken(queryToken);
                if (result.ok) {
                    localStorage.removeItem(ELocalStorageKey.JoinTokenQueryParameter);
                    navigate(USER_MERCHANTS);
                } else {
                    setError(result.body.message);
                }
            } catch (e) {
                logger.error(e);
            }
        } else {
            localStorage.setItem(ELocalStorageKey.JoinTokenQueryParameter, queryToken);
            navigate(`${SIGN_UP}?redirectTo=${JOIN}`);
        }
    }

    if (!error && queryToken) {
        activateTenant();
    }

    return <Throbber text="Verifying your account" />;
}

export default JoinPage;
